import React, { useState } from "react";
import "./matching.css";

function AggregateMatch() {
  const [female, setFemale] = useState({
    name: "",
    dateofbirth: "",
    timeofbirth: "",
    city: "",
    latitude: "",
    longitude: "",
  });

  const [male, setMale] = useState({
    name: "",
    dateofbirth: "",
    timeofbirth: "",
    city: "",
    latitude: "",
    longitude: "",
  });

  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e, person) => {
    const { name, value } = e.target;
    if (person === "female") {
      setFemale({ ...female, [name]: value });
      if (name === "city") fetchCoordinates(value, "female");
    } else {
      setMale({ ...male, [name]: value });
      if (name === "city") fetchCoordinates(value, "male");
    }
  };

  // Fetch coordinates from city using OpenStreetMap
  const fetchCoordinates = async (city, person) => {
    if (!city) return;
    try {
      const res = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(city)}`
      );
      const data = await res.json();
      if (data && data[0]) {
        const { lat, lon } = data[0];
        if (person === "female") {
          setFemale((prev) => ({ ...prev, latitude: lat, longitude: lon }));
        } else {
          setMale((prev) => ({ ...prev, latitude: lat, longitude: lon }));
        }
      }
    } catch (err) {
      console.error("Failed to fetch coordinates:", err);
    }
  };

  const fetchAggregateMatch = () => {
    setError("");
    setResult(null);

    const requiredFields = ["name", "dateofbirth", "timeofbirth", "city"];
    for (let field of requiredFields) {
      if (!female[field]) {
        setError(`Please fill female's ${field}`);
        return;
      }
      if (!male[field]) {
        setError(`Please fill male's ${field}`);
        return;
      }
    }

    setLoading(true);

    // Convert DOB and time into API format
    const [femaleYear, femaleMonth, femaleDate] = female.dateofbirth.split("-");
    const [femaleHours, femaleMinutes] = female.timeofbirth.split(":");

    const [maleYear, maleMonth, maleDate] = male.dateofbirth.split("-");
    const [maleHours, maleMinutes] = male.timeofbirth.split(":");

    fetch(
      `https://api.jyotishamastroapi.com/api/matching/aggregate-match?boy_dob=${maleYear}/${maleMonth}/${maleDate}&boy_tob=${maleHours}:${maleMinutes}&boy_lat=${male.latitude}&boy_lon=${male.longitude}&boy_tz=5.5&girl_dob=${femaleYear}/${femaleMonth}/${femaleDate}&girl_tob=${femaleHours}:${femaleMinutes}&girl_lat=${female.latitude}&girl_lon=${female.longitude}&girl_tz=5.5&lang=en`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          key: "2a10JhmcIyTL81Pivmzo92ynCeS04v",
        },
      }
    )
      .then((res) => {
        if (!res.ok) throw new Error(`API error: ${res.status}`);
        return res.json();
      })
      .then((data) => setResult(data.response || data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  const renderInputs = (personData, person) => {
    const fields = [
      { name: "name", label: "Full Name", type: "text" },
      { name: "dateofbirth", label: "Date of Birth", type: "date" },
      { name: "timeofbirth", label: "Time of Birth", type: "time" },
      { name: "city", label: "City / Place", type: "text" },
    ];

    return fields.map((field) => (
      <div className="matching-form-group" key={field.name}>
        <label>{field.label}</label>
        <input
          type={field.type}
          name={field.name}
          value={personData[field.name]}
          onChange={(e) => handleInputChange(e, person)}
          required
        />
      </div>
    ));
  };

  return (
    <div className="container">
      <div className="ra-main-matchmaking">
        <h2>Aggregate Match</h2>

        <div className="ra-main-form-section">
          <div className="form-section">
            <h3>Female Details</h3>
            <div className="form-grid">{renderInputs(female, "female")}</div>
          </div>

          <div className="form-section">
            <h3>Male Details</h3>
            <div className="form-grid">{renderInputs(male, "male")}</div>
          </div>
        </div>

        <button
          className="match-btn"
          onClick={fetchAggregateMatch}
          disabled={loading}
        >
          {loading ? "Matching..." : "Match"}
        </button>

        {error && <div className="error-msg">Error: {error}</div>}

        {result && (
          <div className="result-section">
            <h3>Result</h3>
            <p style={{ fontWeight: "bold", textAlign: "center" }}>
              {female.name} & {male.name}
            </p>
            <p>
              <strong>Total Score:</strong> {result.score} / 100
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default AggregateMatch;
